/**
 * @Author: Fannie
 * @Date:   2018-04-25T08:55:02+08:00
 * @Last modified by:

 * @Last modified time: 2018-04-25T08:55:02+08:00
 */

import _util from '../../utils/';

const applicationCenterService = {
  changePassword(posts, resolve, reject) {
    _util.request({
      url: '/api/auth/reset_password',
      method: 'post',
      data: posts,
      success: resolve,
      error: reject
    });
  },
  changeSecondPassword(posts, resolve, reject) {
    _util.request({
      url: '/api/auth/change_second_password',
      method: 'post',
      data: posts,
      success: resolve,
      error: reject
    });
  },
    addApplyLeave(posts, resolve, reject) {
        _util.request({
            url: '/api/ApplicationCenter/LeavePost',
            method: 'post',
            data: posts,
            success: resolve,
            error: reject
        });
    },
    addApplyAnnualLeave(posts, resolve, reject) {
        _util.request({
            url: '/api/ApplicationCenter/LeavePost',
            method: 'post',
            data: posts,
            success: resolve,
            error: reject
        });
    },
    fetchLeaveType (params, resolve, reject) {
        _util.request({
            url: '/api/Common/GetLeaveTypeListEnum',
            params: params,
            success: resolve,
            error: reject
        })
    },
    addApplyBreakDown(posts, resolve, reject) {
        _util.request({
            url: '/api/ApplicationCenter/RelaxationPost',
            method: 'post',
            data: posts,
            success: resolve,
            error: reject
        });
    },
    addApplySpecialBreakDown(posts, resolve, reject) {
      _util.request({
          url: '/api/ApplicationCenter/SpecialRelaxationPost',
          method: 'post',
          data: posts,
          success: resolve,
          error: reject
      });
  },
    addApplyOvertime(posts, resolve, reject) {
        _util.request({
            url: '/api/ApplicationCenter/OvertimePost',
            method: 'post',
            data: posts,
            success: resolve,
            error: reject
        });
    },
    addApplyGoOut(posts, resolve, reject) {
        _util.request({
            url: '/api/ApplicationCenter/GooutPost',
            method: 'post',
            data: posts,
            success: resolve,
            error: reject
        });
    },

    addApplyBusiness(posts, resolve, reject) {
        _util.request({
            url: '/api/ApplicationCenter/TravelingPost',
            method: 'post',
            data: posts,
            success: resolve,
            error: reject
        });
    },
    fetchApplicationList(gets, resolve, reject) {
        _util.request({
            url: '/api/ApplicationCenter/ApprovalLog',
            params: gets,
            success: resolve,
            error: reject
        })
    },
    fetchApplicationDetail(gets, resolve, reject) {
        _util.request({
            url: '/api/ApplicationCenter/ApprovalLogDetail',
            params: gets,
            success: resolve,
            error: reject
        })
    },
    UndoApproval(posts, resolve, reject) {
        _util.request({
            url: '/api/ApplicationCenter/UndoApproval',
            method: 'post',
            data: posts,
            success: resolve,
            error: reject
        });
    },
    UrgeApproval (posts, resolve, reject) {
        _util.request({
            url: '/api/ApplicationCenter/UrgeApproval ',
            method: 'post',
            data: posts,
            success: resolve,
            error: reject
        });
    },
    //我的加班申请
    myOvertimeApply(data, resolve, reject) {
        _util.request({
            url: '/api/HRApprovalOvertime/MyGet',
            params: data,
            success: resolve,
            error: reject
        })
    },
    //我的调休申请
    myBreakDownApply(data, resolve, reject) {
        _util.request({
            url: '/api/HRApprovalRelaxation/MyGet',
            params: data,
            success: resolve,
            error: reject
        })
    },
    //我的请假申请
    myLeaveApply(data, resolve, reject) {
        _util.request({
            url: '/api/HRApprovalLeave/MyGet',
            params: data,
            success: resolve,
            error: reject
        })
    },
    //我的外出申请
    myGoOutApply(data, resolve, reject) {
        _util.request({
            url: '/api/HRApprovalGoout/MyGet',
            params: data,
            success: resolve,
            error: reject
        })
    },
    //我的出差申请
    myBusinessApply(data, resolve, reject) {
        _util.request({
            url: '/api/HRApprovalTraveling/MyGet',
            params: data,
            success: resolve,
            error: reject
        })
    },
  //我的日报
  myDailyReport(data, resolve, reject) {
    _util.request({
      url: '/api/HRWorkReportDailyManagement/Get',
      params: data,
      success: resolve,
      error: reject
    })
  },
  //我的日报详情
  myDailyReportDetail(data, resolve, reject) {
    _util.request({
      url: '/api/HRWorkReportDailyManagement/Details',
      params: data,
      success: resolve,
      error: reject
    })
  },
  //我的周报
  myWeeklyReport(data, resolve, reject) {
    _util.request({
      url: '/api/HRWorkReportWeeklyManagement/Get',
      params: data,
      success: resolve,
      error: reject
    })
  },
  //我的周报详情
  myWeeklyReportDetail(data, resolve, reject) {
    _util.request({
      url: '/api/HRWorkReportWeeklyManagement/Details',
      params: data,
      success: resolve,
      error: reject
    })
  },
  //我的月报
  myMonthlyReport(data, resolve, reject) {
    _util.request({
      url: '/api/HRWorkReportMonthlyManagement/Get',
      params: data,
      success: resolve,
      error: reject
    })
  },
  //我的月报详情
  myMonthlyReportDetail(data, resolve, reject) {
    _util.request({
      url: '/api/HRWorkReportMonthlyManagement/Details',
      params: data,
      success: resolve,
      error: reject
    })
  },
  learveManager(posts, resolve, reject) {
    _util.request({
      url: '/api/HRApprovalLeave/ManagerBatchPost',
      method: 'post',
      data: posts,
      success: resolve,
      error: reject
    });
  },
  relaxioneManager(posts, resolve, reject) {
    _util.request({
      url: '/api/HRApprovalRelaxation/ManagerBatchPost',
      method: 'post',
      data: posts,
      success: resolve,
      error: reject
    });
  },
  overtimeManager(posts, resolve, reject) {
    _util.request({
      url: '/api/HRApprovalOvertime/ManagerBatchPost',
      method: 'post',
      data: posts,
      success: resolve,
      error: reject
    });
  },
  gooutManager(posts, resolve, reject) {
    _util.request({
      url: '/api/HRApprovalGoout/ManagerBatchPost',
      method: 'post',
      data: posts,
      success: resolve,
      error: reject
    });
  },
  TravelingManager(posts, resolve, reject) {
    _util.request({
      url: '/api/HRApprovalTraveling/ManagerBatchPost',
      method: 'post',
      data: posts,
      success: resolve,
      error: reject
    });
  },

  fetchAttendanceDetail(gets, resolve, reject) {
    _util.request({
        url: '/api/ApplicationCenter/AttendanceDetail',
        params: gets,
        success: resolve,
        error: reject
    })
},
ApplyAttendance(posts, resolve, reject) {
  _util.request({
    url: '/api/ApplicationCenter/AttendancePost',
    method: 'post',
    data: posts,
    success: resolve,
    error: reject
  });
},

}


export default applicationCenterService;


// WEBPACK FOOTER //
// ./src/services/Employee/application-center-service.js